import * as React from 'react';
import { Group } from '@visx/group';
import { Crosshatch } from './Crosshatch';
import { useCanvas } from '../../components/Canvas';
export function Bar(_a) {
    var colorScale = _a.colorScale, barScale = _a.barScale, yScale = _a.yScale, _b = _a.crosshatchColor, crosshatchColor = _b === void 0 ? 'rgba(255,255,255,0.85)' : _b, id = _a.id, y = _a.y, y1 = _a.y1;
    var boundedHeight = useCanvas().boundedHeight;
    var patternId = id + ":crosshatch";
    var yScaled = yScale(y);
    var yHeight = boundedHeight - yScaled;
    var y1Scaled = y1 != null ? yScale(y1) : undefined;
    var y1Height = y1Scaled != null ? boundedHeight - y1Scaled : undefined;
    var barWidth = barScale.bandwidth();
    var barX = barScale(id);
    return (React.createElement(Group, null,
        React.createElement(Crosshatch, { id: patternId, color: crosshatchColor }),
        React.createElement("rect", { fill: colorScale(id), height: yHeight + (y1Height !== null && y1Height !== void 0 ? y1Height : 0), width: barWidth, x: barX, y: y1 != null ? (y1Scaled !== null && y1Scaled !== void 0 ? y1Scaled : 0) - yHeight : yScaled }),
        y1 != null && y1Height != null && (React.createElement(React.Fragment, null,
            React.createElement("rect", { fill: "url(#" + patternId + ")", height: y1Height, width: barWidth, x: barX, y: (y1Scaled !== null && y1Scaled !== void 0 ? y1Scaled : 0) - yHeight }),
            React.createElement("rect", { x: barX, width: barWidth, y: (y1Scaled !== null && y1Scaled !== void 0 ? y1Scaled : 0) - yHeight + y1Height, height: 0.5, fill: crosshatchColor })))));
}
//# sourceMappingURL=Bar.js.map